import { render, staticRenderFns } from "./kf_PerformanceStatistics.vue?vue&type=template&id=7b1d2252"
import script from "./kf_PerformanceStatistics.vue?vue&type=script&lang=js"
export * from "./kf_PerformanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./kf_PerformanceStatistics.vue?vue&type=style&index=0&id=7b1d2252&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports